import * as React from "react";
import {
  Stack,
  Select,
  MenuItem as SelectMenuItem,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";

const COMMISSION_BASE_OPTIONS = [
  {
    value: "gross",
    label: "Gross collected",
    description: "Commission = gross collected × rate / 100. Rate cannot exceed landlord pay %.",
  },
  {
    value: "net",
    label: "Net (after landlord fee)",
    description:
      "Commission = (gross × landlord pay % / 100) × rate / 100. Rate cannot exceed 100%.",
  },
];

export function BrokerLandlordsForm({
  newLandlord,
  brokerCommissionRate,
  commissionBase = "gross",
  handleChange,
  handleCommissionRateChange,
  handleCommissionBaseChange,
  landlords,
  isLoadingLandlords,
  selectedLandlordMaxRate,
}) {
  const isNetBase = commissionBase === "net";
  const rateHelper = isNetBase
    ? "Net base: rate must be ≤ 100%."
    : selectedLandlordMaxRate != null
    ? `Gross base: rate must be ≤ landlord pay percentage (${selectedLandlordMaxRate}%).`
    : "Gross base: rate must not exceed landlord pay percentage.";

  return (
    <Stack spacing={2}>
      {isLoadingLandlords ? (
        <Typography variant="body2">Loading landlords…</Typography>
      ) : (
        <>
          <FormControl fullWidth>
            <InputLabel id="related-landlord-label">Select Landlord</InputLabel>
            <Select
              labelId="related-landlord-label"
              id="related-landlord"
              name="related_landlord"
              value={newLandlord || ""}
              onChange={handleChange}
              label="Select Landlord"
            >
              {landlords.map((landlord) => (
                <SelectMenuItem key={landlord.id} value={landlord.id}>
                  {landlord.business_name ||
                    `${landlord.related_user?.first_name || ""} ${landlord.related_user?.last_name || ""}`.trim() ||
                    `Landlord #${landlord.id}`}
                </SelectMenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="commission-base-label">Commission base</InputLabel>
            <Select
              labelId="commission-base-label"
              id="commission_base"
              value={commissionBase}
              onChange={handleCommissionBaseChange}
              label="Commission base"
            >
              {COMMISSION_BASE_OPTIONS.map((option) => (
                <SelectMenuItem key={option.value} value={option.value}>
                  {option.label}
                </SelectMenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="caption" color="text.secondary">
            {COMMISSION_BASE_OPTIONS.find((o) => o.value === commissionBase)?.description}
          </Typography>
          <TextField
            fullWidth
            type="number"
            label="Broker commission rate (%)"
            value={brokerCommissionRate}
            onChange={handleCommissionRateChange}
            inputProps={{ min: 0, step: 0.1, max: isNetBase ? 100 : undefined }}
            required
            helperText={rateHelper}
          />
        </>
      )}
    </Stack>
  );
}
